import React, { useState, useEffect } from 'react';
import { WifiOff, CloudOff, RefreshCw } from 'lucide-react';
import { getPendingCount, replayQueue } from '../utils/offlineQueue';
import { useAuth } from '../AuthContext';
import { useI18n } from '../I18nContext';

function OfflineBanner() {
  const { t } = useI18n();
  const [online, setOnline] = useState(navigator.onLine);
  const [pendingCount, setPendingCount] = useState(0);
  const { authFetch } = useAuth();
  const [replaying, setReplaying] = useState(false);

  const updatePending = async () => setPendingCount(await getPendingCount());

  useEffect(() => {
    const go = () => { setOnline(true); updatePending(); };
    const goff = () => setOnline(false);
    window.addEventListener('online', go);
    window.addEventListener('offline', goff);
    updatePending();
    const interval = setInterval(updatePending, 5000);
    return () => {
      window.removeEventListener('online', go);
      window.removeEventListener('offline', goff);
      clearInterval(interval);
    };
  }, []);

  const handleReplay = async () => {
    setReplaying(true);
    await replayQueue(authFetch);
    await updatePending();
    setReplaying(false);
  };

  if (online && pendingCount === 0) return null;

  const bannerClass = 'fixed bottom-0 inset-x-0 z-[1000] flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-semibold text-white';

  if (!online) {
    return (
      <div className={`${bannerClass} bg-error`}>
        <WifiOff size={16} /> {t('common.offline')}
      </div>
    );
  }

  return (
    <div className={`${bannerClass} bg-warning`}>
      <CloudOff size={16} /> {t('common.pendingSync', { count: pendingCount })}
      <button
        onClick={handleReplay}
        disabled={replaying}
        className="flex items-center gap-1 bg-white/20 border-none text-white rounded-lg px-3 py-1 text-xs font-semibold cursor-pointer hover:bg-white/30 disabled:opacity-60"
      >
        <RefreshCw size={12} /> {replaying ? t('common.saving') : t('common.syncNow')}
      </button>
    </div>
  );
}

export default OfflineBanner;
